import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../../../../utils/AppUtils";
import SubscriptionPriceSectionComponent from "../../SubscriptionPage/SubscriptionPriceSection/SubscriptionPriceSectionComponent";
import TestimonialComponent from "../../Testimonial/TestimonialComponent";
import XselAdvantagePanelComponent from "../XselAdvantagePanel/XselAdvantagePanelComponent";
import "./GuestHomePageComponent.scss";
import "./BelowBanner.scss";
import FreeVideos from "../../UsefulEntity/FreeVideos";
import PopularFreeCourses from "../../UsefulEntity/PopularFreeCourses";
import PopularCertifications from "../../UsefulEntity/PopularCertifications";
import VideoPlayer from "react-video-js-player";
import RecommendationEnginePage from "../../../../pages/B2C-Pages/RecommendationEnginePage";

const GuestHomePageComponent = (props) => {
  const navigate = useNavigate();

  const redirectToSignUp = () => {
    clickStreamUser("clicked-login-btn", {
      is_guest_user: true,
      session_id: localStorage.getItem("sessionId"),
    });
    navigate("/sign-up?p=1");
  };

  const renderBanner = () => {
    return (
      <section className="bannersection-home">
        <div className="container mob-rev">
          <div className="col-lg-6 col-12 leftsec">
            <h1>Real learning for real success</h1>
            <p>
              Are you a budding agent looking to jump start your career—or a
              seasoned pro aiming to stay ahead of the curve? Wherever you are
              in your real estate journey, you can take your career to new
              heights with the Xsel real estate learning platform.{" "}
            </p>
            <p>
              The only learning platform designed specifically for real estate
              agents, cloud-based Xsel uses AI to deliver personalized learning
              paths, from onboarding and compliance to upskilling. Elevate your
              expertise with best-in-class content and the industry’s most
              advanced technology.
            </p>

            <button
              type="button"
              className="default-btn"
              onClick={() => redirectToSignUp()}
            >
              Subscribe free today
            </button>
          </div>
          <div className="col-lg-6 col-12 rightsec"></div>
        </div>
      </section>
    );
  };

  const onPlayerReady = (player) => {
    player.src("");
    // let videoData = videoDetailInfo[0];
    // player.src({
    //   src: videoData.video_link,
    //   withCredentials: true,
    // });
    const trackEl = player.addRemoteTextTrack(
      {
        // src: videoData?.subtitle_url,
        kind: "captions",
        srclang: "en",
        label: "English",
      },
      false
    );
    trackEl.addEventListener("load", function () {});
    window.scrollTo(0, 50);
  };

  const renderGetStartedSection = () => {
    return (
      <section className="belowbanner">
        <div className="container text-center">
          <h2 htmlFor="">Jump start your career today—free!</h2>
          <p>
            Register with Xsel to get access to comprehensive training courses,
            expert insights, and invaluable career resources—all at no cost to
            you. Whether you're a beginner or a seasoned pro, our free
            subscription is your passport to learning and growing in the real
            estate industry.
          </p>
          <p>
            <b>Don't miss out on this opportunity:</b> Sign up now and unlock
            your future in real estate—no strings attached!
          </p>

          <button
            className="subscriptionbtn"
            onClick={() => redirectToSignUp()}
          >
            Get your free subscription
          </button>
          <div className="vieosec">
            {/* <iframe
              className="w-100"
              src={"https://www.youtube.com/embed/p4J-MbXOaqE"}
              title={"Real Estate Video"}
              height="100%"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              width="100%"
            /> */}
            <VideoPlayer
              className="img-videosec-home learn_image-card"
              controls={true}
              src={
                "https://rsplearning-dev.niit-mts.com/meeting/images/617527938043218.mp4"
              }
              width="100%"
              height="516"
              autoPictureInPicture={true}
              // poster={!showLearnMore ? item?.product_thumbnail : ""}
              fluid={true}
              inline={false}
              pictureInPictureToggle={true}
              type={"video/mp4"}
              onReady={onPlayerReady}
              crossorigin="use-credentials"
            />
          </div>
        </div>
      </section>
    );
  };
  return (
    <>
      {renderBanner()}
      <XselAdvantagePanelComponent />
      <PopularFreeCourses />
      <FreeVideos />
      <SubscriptionPriceSectionComponent {...props} />
      {renderGetStartedSection()}
      <PopularCertifications />
      <TestimonialComponent />
      <RecommendationEnginePage />
    </>
  );
};

export default GuestHomePageComponent;
